import { Grid } from "@mui/material";
import SearchCoach from "./search/searchCoach";
import SearchFromDate from "./search/searchFromDate";
import SearchToDate from "./search/searchToDate";
import SearchStarMax from "./search/searchStarMax";
import SearchStarMin from "./search/searchStarMin";
import SearchStartButton from "./search/searchStartButton";
import React from "react";
import { User, AppContext } from "../../../context/appContext";
import checkPermissionAdmin from "../../../functions/checkPermissionAdmin";

const SearchInputs = (): React.JSX.Element => {
  const {
    user,
  }: {
    user: User;
  } = React.useContext(AppContext);

  return (
    <React.Fragment>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {/* hide coach select if user is not admin */}
        {checkPermissionAdmin(user) && (
          <Grid item xs={12} sm={12} md={3}>
            <SearchCoach />
          </Grid>
        )}

        <Grid item xs={6} sm={4} md>
          <SearchFromDate />
        </Grid>

        <Grid item xs={6} sm={4} md>
          <SearchToDate />
        </Grid>

        <Grid item xs={6} sm={4} md>
          <SearchStarMin />
        </Grid>

        <Grid item xs={6} sm={4} md>
          <SearchStarMax />
        </Grid>

        <Grid item xs={12} sm={4} md={2}>
          <SearchStartButton />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default SearchInputs;
